<template>
  <div>
    <div class="hdp-head">
      <StepBack @route="onRoute" :route="{name: 'HomeView'}" />
      <div class="hdp-h1">{{ folder.name }}</div>
    </div>
    <ArticlesList :articles="articles" @route="onRoute" />
  </div>
</template>

<script>
import ArticlesList from '@/components/ArticlesList'
import StepBack from '@/components/StepBack'
import api from '@/api'
import utils from '@/utils'

export default {
  name: 'FolderView',

  components: {
    ArticlesList,
    StepBack
  },

  data () {
    return {
      folder: [],
      articles: []
    }
  },

  props: {
    params: {
      type: Object,
      required: true
    }
  },

  created () {
    utils.tealiumTrack(this, {
      page_type: 'article list'
    })

    Promise.all([
      api.getFolder({ folderId: this.params.folderId, lang: this.$lang }),
      api.getArticles({ folderId: this.params.folderId, lang: this.$lang })
    ]).then(([ folder, articles ]) => {
      this.folder = folder
      this.articles = articles
    })
  },

  watch: {
    params: function () {
      Promise.all([
        api.getFolder({ folderId: this.params.folderId, lang: this.$lang }),
        api.getArticles({ folderId: this.params.folderId, lang: this.$lang })
      ]).then(([ folder, articles ]) => {
        this.folder = folder
        this.articles = articles
      })
    }
  },

  methods: {
    onRoute (route) {
      this.$emit('route', route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/FolderView.vue